<template>
	<div>
		<KButton
			height="34px"
			width="unset"
			font-weight="400"
			font-size="0.8125rem"
			border-radius="0.25rem"
			title="Exportar"
			margin-left="10px"
			margin-right="10px"
			:icon="{ color: '#8b83ba', size: '18px', type: 'file-text' }"
			@click="openModalExport"
		/>
		<Modal
			v-if="modalActive"
			title="Exportar"
			@download="getDataFilter($event)"
			@close="modalActive = false"
		/>
	</div>
</template>

<script>
import XlsExport from '../../../services/xls-export';
import Modal from '../modal/payment';
import global from '../../../mixins/global';
import * as ecAxios from '../../../util/ecAxios';
import KButton from '../buttons/Default';

export default {
	components: {
		Modal,
		KButton,
	},
	mixins: [global],
	data() {
		return {
			filters: JSON.parse(localStorage.getItem('filter-cartao')),
			modalActive: false,
			isLoading: true,
			dados: [],
		};
	},
	methods: {
		openModalExport() {
			this.modalActive = true;
		},
		async getDataFilter(data) {
			const event = JSON.parse(localStorage.getItem('filters-precadastro'));
			this.isLoading = true;
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIO_CADASTROS}`, {
					cidade: event.cidadeData,
					dateRange: event.dateRange,
					sintegrastatus: event.sintegrastatus,
					situacao: event.situacao,
					status: event.status,
					motstatus: event.motStatusData,
					uf: event.estadosData,
					direction: event.direction ? event.direction : 'desc',
					orderby: event.orderby ? event.orderby : 'created_at',
					searchTerm: event.searchTerm,
				})
				.then((response) => {
					if (response.data.error === 0) {
						this.dados = response.data.usuarioCadastros;
						this.exportExel(data);
					}
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e.toString(),
						type: 'is-danger',
					});
				});
		},
		verifyStatusRow(status) {
			if (status === 1) {
				return 'Ativo';
			}
			if (status === 0) {
				return 'Inativo';
			}
			if (status === 2) {
				return 'Arquivado';
			}
			return '~';
		},
		getSintegraStatus(data) {
			let { sintegrastatus, receitastatus } = data;
			const sintegraId = sintegrastatus;
			sintegrastatus = parseInt(sintegrastatus, 10);
			if (sintegrastatus === 1) {
				sintegrastatus = 'Liberado';
			} else if (sintegrastatus === 0 && sintegrastatus !== '') {
				sintegrastatus = 'Bloqueado';
			} else {
				sintegrastatus = '';
			}
			if (receitastatus !== '' && receitastatus !== null) {
				if (receitastatus !== null) {
					receitastatus = `${receitastatus} (RF)`;
				}
				if (sintegrastatus) {
					sintegrastatus = `${`${sintegrastatus} / ${receitastatus}`}`;
				} else {
					sintegrastatus = receitastatus;
				}
			}
			return { sintegrastatus, sintegraId };
		},
		exportExel(data) {
			const newData = [];
			this.dados.map((item) => {
				const newIndex = {
					'SEQ. PESSOA': item.integracao_id,
					CÓDIGO: item.id,
					'COD. REPRESENTANTE': item.representante,
					SITUACÃO: item.situacaodesc,
					'RAZÃO SOCIAL': item.nomerazao,
					CNPJ: this.formatCnpjCpf(item.cnpj),
					CNAE: item.cnae,
					UF: item.uf,
					CIDADE: item.cidade,
					'DATA DE CRIAÇÃO': item.created_at,
					EMAIL: item.email,
					'STATUS SOLICITAÇÃO': this.verifyStatusRow(item.status),
					'MOTIVO STATUS': item.motstatusdesc,
					'SITUAÇÃO SINTEGRA / RF': this.getSintegraStatus({
						sintegrastatus: item.sintegrastatus,
						receitastatus: item.receitastatus,
					}).sintegrastatus,
					OBSERVAÇÕES: item.observacao,
				};
				newData.push(newIndex);
				return newIndex;
			});
			let filename = '';
			const xls = new XlsExport(newData);
			if (data.nome !== '') {
				filename = `${data.nome}${data.formato}`;
			} else {
				filename = `${new Date().toLocaleString()}${data.formato}`;
			}
			switch (data.formato) {
				case '.xls':
					xls.exportToXLS(filename);
					break;
				case '.csv':
					xls.exportToCSV(filename);
					break;

				default:
					break;
			}
		},
	},
};
</script>

<style scoped>
.container-modal-ex {
	display: flex;
	align-items: center;
}
.xlsformat {
	cursor: pointer;
}
.xlsformat {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 60px;
	height: 30px;
	border: 1px solid #cececea9;
}
.btncancel {
	margin-top: 20px;
	height: 40px;
	margin-right: 15px;
}
.btn-export {
	cursor: pointer;
}
</style>

